export default "__VITE_ASSET__BvV1xPGJ__"